<template>
  <vddl-draggable
    :key="item.id"
    :draggable="item"
    :index="index"
    :wrapper="list"
    :dragstart="onDragStart"
    :dragend="onDragEnd"
    :moved="onMove"
    :canceled="onCancel"
    :type="type"
    :disable-if="!canEdit"
  >
    <div
      class="audio-ref"
      :draggable="true"
      @drag="onAssetDrag"
      @dragstart="onAssetStartDrag($event, item)"
      @mousedown="onMousedownAsset"
      @mouseup="onMouseupAsset"
      @click="onClickAsset($event, item)"
      @contextmenu.prevent="onContextMenu"
    >
      <svg-icon :icon="modeIcon" width="22" height="22" />
      <div class="asset-name">{{ item.name }}</div>
    </div>
  </vddl-draggable>
</template>

<script>
import { mapActions } from 'vuex';
import { useProtect } from '@/composables/useProtect.js';
import emitter from 'tiny-emitter/instance';
import { SYS_PERMISSIONS, EVENT, DRAG_LIST } from '@/constants.js';
import SvgIcon from '../../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  props: {
    id: {
      type: String,
      default: null,
    },
    list: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    moveAction: {
      type: Function,
      default: () => {},
    },
    deleteAction: {
      type: Function,
      default: () => {},
    },
  },

  setup() {
    const { hasPermission: canEdit } = useProtect({
      permissions: [SYS_PERMISSIONS.SYS_PROJECTS_EDIT],
      roles: ['editor'],
    });

    return {
      canEdit,
    };
  },

  computed: {
    assetRef() {
      return this.list[this.index];
    },

    modeIcon() {
      switch (this.assetRef.mode) {
        case 'once':
          return 'app-icons/audio-start';
        case 'loop':
          return 'app-icons/audio-loop';
        case 'stop':
          return 'app-icons/audio-stop';
        default:
          break;
      }
      return 'app-icons/audio-start';
    },
  },

  methods: {
    ...mapActions('application/contextMenu', [
      'createItem',
      'setCalcPosition',
      'deleteMenu',
    ]),
    ...mapActions('application/modals', [
      'setAudioAssetRefModal',
      'setAudioAssetModal',
    ]),
    ...mapActions('application/drag', ['setItems', 'setSource', 'clear']),

    onDragStart() {
      this.setItems({
        value: {
          type: this.type,
          ids: [this.item.id],
        },
      });
      this.setSource({
        value: {
          type: DRAG_LIST.ASSETS,
          ids: [this.id],
          indexes: [this.index],
        },
      });
    },

    onAssetStartDrag(event, item) {},

    onDragEnd() {},

    onMove(event) {
      console.log('AudioAssetCollectionItem::onMove');
      this.moveAction();
    },

    onCancel() {
      this.clear();
    },

    onAssetDrag($event) {
      emitter.emit(EVENT.DRAGGING_AUDIO_ASSET, $event);
    },

    onMousedownAsset(event) {
      this.$emit('disableDrag', event);
    },

    onMouseupAsset(event) {
      this.$emit('enableDrag', event);
    },

    onClickAsset(event, item) {
      if (!this.canEdit) {
        this.setAudioAssetModal({
          value: {
            id: this.item.id,
          },
        });
        return;
      }
      this.setAudioAssetRefModal({
        value: {
          id: item.id,
          elementId: this.id,
          index: this.index,
          apply: true,
        },
      });
    },

    onContextMenu(event) {
      if (this.canEdit) {
        this.createContextMenu(event.clientX, event.clientY);
      }
    },

    async createContextMenu(x, y) {
      this.createItem({
        name: 'Remove reference',
        icon: null,
        commands: {
          doAction: () => {
            this.deleteAction(this.id, this.index);
            this.deleteMenu();
          },
          isActive: () => true,
          isEnabled: () => true,
        },
        submenu: null,
      });

      this.setCalcPosition({
        calcPosition: () => {
          return { left: x, top: y };
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-ref {
  display: flex;
  font-size: 0.8em;
  gap: 10px;
  padding: 10px 20px;
  cursor: pointer;
  transition: color 0.25s;

  &:hover {
    color: #ffffff;
  }

  .asset-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
